/* eslint-disable react/require-default-props */
import React from 'react';
import { bool, func, oneOf, string } from 'prop-types';
import { GLOBAL } from '@Config/global';
import './styles.scss';

const { MODAL } = GLOBAL;
function ConfirmationModal({
  icon = 'bi bi-exclamation-circle',
  status = 'primary',
  onConfirm,
  onDismiss,
  onCancel,
  isLoading = false,
  loadingText = 'Procesando…',
  message = MODAL.BODY,
  title = MODAL.TITLE
}) {
  const handleClose = () => {
    if (isLoading) return;
    if (onCancel) {
      onCancel();
    } else if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-busy={isLoading}
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0 justify-content-end">
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            />
          </div>

          <div className="modal-body text-center">
            {status === 'warning' && (
              <div className="mb-3">
                <i className={icon} style={{ fontSize: '3rem', color: '#ffc107' }}></i>
              </div>
            )}

            <h5 className="modal-title mb-3">{title}</h5>
            <p className="text-secondary">{message}</p>
          </div>

          <div className="modal-footer border-0 d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onDismiss}
              disabled={isLoading}
            >
              {MODAL.CANCEL_BUTTON}
            </button>

            <button
              type="button"
              className={`btn btn-${status}`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <span role="status">
                  <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
                  {loadingText}
                </span>
              ) : MODAL.CONFIRM_BUTTON}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ConfirmationModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  onCancel: func,
  isLoading: bool,
  loadingText: string,
  message: string,
  title: string,
  status: oneOf(['primary', 'warning', 'error', 'success']),
  icon: string
};

export default ConfirmationModal;
